<template>
  <div class="white_box">
    <div class="tabs">
      <tab-button
        :active="selectedTab === 1"
        @select="selectedTab = 1"
      >
        Owner Media
      </tab-button>
      <tab-button
        :active="selectedTab === 2"
        @select="selectedTab = 2"
      >
        Customer Media
      </tab-button>
    </div>

    <div
      v-if="selectedTab === 1"
      class="media_tab"
    >
      <div class="media_items">
        <div
          v-if="!profileMediaItem && !coverMediaItem && mediaItems && mediaItems.length === 0"
          class="no_media"
        >
          <div>
            <add-media
              v-if="canEditLocation"
              @click="openAddMediaModal"
            >
              Add Media
            </add-media>
            <p>We currently have no media items for this location. We'd recommend adding some.</p>
          </div>
        </div>
        <div v-else>
          <add-media
            v-if="canEditLocation"
            @click="openAddMediaModal"
          >
            Add Media
          </add-media>

          <profile-cover-media-item
            v-if="profileMediaItem"
            :media-item="profileMediaItem"
            parent="ManageMedia"
            type="profile"
          />

          <profile-cover-media-item
            v-if="coverMediaItem"
            :media-item="coverMediaItem"
            parent="ManageMedia"
            type="cover"
          />

          <media-item
            v-for="(mediaItem, index) in mediaItems"
            :key="index"
            :media-item="mediaItem"
          />
        </div>
      </div>
      <div
        v-if="nextMediaItemsCursor"
        class="more_media_items"
      >
        <span>Loading more</span>
        <i class="fa fa-spinner fa-spin" />
      </div>
    </div>

    <div
      v-if="selectedTab === 2"
      class="media_tab"
    >
      <div v-if="customerMediaItems && customerMediaItems.length > 0">
        <div class="media_items">
          <div>
            <media-item
              v-for="(mediaItem, index) in customerMediaItems"
              :key="index"
              :media-item="mediaItem"
            />
          </div>
        </div>
        <div
          v-if="nextCustomerMediaItemsCursor"
          class="more_customer_media_items"
        >
          <span>Loading more</span>
          <i class="fa fa-spinner fa-spin" />
        </div>
      </div>
      <div
        v-if="customerMediaItems && customerMediaItems.length === 0"
        class="no_media"
      >
        <p>We currently have no customer media items for this location. See if you can get some!</p>
      </div>
    </div>

    <add-media-modal
      v-if="addMediaModalOpen"
      @close="closeAddMediaModal"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AddMedia from "../items/AddMedia";
import MediaItem from "../items/MediaItem";
import ProfileCoverMediaItem from "../items/ProfileCoverMediaItem";
import TabButton from "../../../global/buttons/TabButton";
import AddMediaModal from "../modals/AddMediaModal";

export default {
  components: {
    AddMediaModal,
    TabButton,
    AddMedia,
    MediaItem,
    ProfileCoverMediaItem,
  },
  data() {
    return {
      selectedTab: 1,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'selectedLocation',
      'coverMediaItem',
      'profileMediaItem',
      'mediaItems',
      'nextMediaItemsCursor',
      'customerMediaItems',
      'nextCustomerMediaItemsCursor',
      'isInViewport',
      'addMediaModalOpen',
    ]),
  },
  mounted() {
    document.onscroll = () => {
      const loadMediaItemsEl = document.querySelector('.more_media_items');
      this.loadMore(loadMediaItemsEl, 'fetchMoreMediaItems');

      const loadCustomerMediaItemsEl = document.querySelector('.more_customer_media_items');
      this.loadMore(loadCustomerMediaItemsEl, 'fetchMoreCustomerMediaItems');
    }
  },
  methods: {
    ...mapActions('businessProfile', [
      'fetchMoreMediaItems',
      'fetchMoreCustomerMediaItems',
      'openAddMediaModal',
      'closeAddMediaModal',
    ]),
    loadMore(el, functionName) {
      if (
          el &&
          this.isInViewport(el) &&
          this.loading === false
      ) {
        this.loading = true;
        this[functionName](this.selectedLocation).then(() => {
          this.loading = false
        });
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
}

.media_items div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.more_media_items, .more_customer_media_items {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 1.5rem;
  }

  i {
    margin-left: .5rem;
  }
}

.no_media {
  margin-top: 2rem;

  p {
    color: var(--primary-color);
    text-align: center;
  }

  div {
    display: flex;
    justify-content: center;
    gap: 2rem;

    p {
      margin: 0;
    }
  }
}
</style>
